import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import PropTypes from "prop-types";
import { TextLinkCaret as CoreTextLinkCaret } from "@vds-core/buttons";
import { calculateRem } from "@uie/javascript-style-helpers";
var propTypes = {
  /**
   * Component will render in Inverted state.
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  inverted: false
};

var _calculateLetterSpacing = function _calculateLetterSpacing() {
  return calculateRem("0.5px");
};

var _calculateActiveColor = function _calculateActiveColor() {
  return "#747676"; // CoolGray6
};

var TextLinkCaret = function TextLinkCaret(props) {
  return /*#__PURE__*/React.createElement(CoreTextLinkCaret, _extends({}, props, {
    surface: props.inverted ? "dark" : "light",
    focusRingBorderRadius: "0",
    calculateActiveColor: _calculateActiveColor,
    calculateLetterSpacing: _calculateLetterSpacing
  }));
};

TextLinkCaret.propTypes = propTypes;
TextLinkCaret.defaultProps = defaultProps;
export default TextLinkCaret;